import { useMemo } from 'react';

import { useLiveQuery } from 'dexie-react-hooks';

import db, { DEXIE_IS_LOADING } from './db';

const EMPTY_IDS = [];

function normalizeChannelIds(raw) {
  if (raw === DEXIE_IS_LOADING) return EMPTY_IDS;
  return [...new Set(raw.map((ch) => String(ch.id)).filter((id) => id && !id.startsWith('skeleton_')))];
}

/** Global reporter feeds title/favicon and Electron dock. */
export function useUnreadReportChannelIds() {
  const raw = useLiveQuery(() => db.channels.toArray(), [], DEXIE_IS_LOADING);

  return useMemo(() => normalizeChannelIds(raw), [raw]);
}
